import { render, staticRenderFns } from "./BasketSetting.vue?vue&type=template&id=542ebc1b&"
import script from "./BasketSetting.vue?vue&type=script&lang=js&"
export * from "./BasketSetting.vue?vue&type=script&lang=js&"
import style0 from "./BasketSetting.vue?vue&type=style&index=0&id=542ebc1b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports